<template>
  <div>
    <div class="title">账户余额是否可以提现？</div>
    <div class="content-info">
      <p class="txt1">暂不支持提现。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
